(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    customElements.define(
      'before-after-slider',
      class BeforeAfterSlider extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
          } else {
            this.setup();
          }
        }

        setup() {
          if (this.ready) return;
          this.handle = this.querySelector('[data-handle]');
          if (!this.handle) return;
          this.ready = true;

          const start = parseFloat(this.dataset.start);
          this.value = Number.isFinite(start) ? start : 50;
          this.pointerId = null;
          this.dragging = false;
          this.pending = null;
          this.grab = 0;

          this.addEventListener('pointerdown', (event) => this.onDown(event));
          this.addEventListener('pointermove', (event) => this.onMove(event));
          this.addEventListener('pointerup', (event) => this.onEnd(event));
          this.addEventListener('pointercancel', (event) => this.onEnd(event));
          // Only our own capture counts here. A touch also hands the picture an implicit capture,
          // and that one being swapped for ours must not end the slide.
          this.addEventListener('lostpointercapture', (event) => {
            if (event.target === this) this.onEnd(event);
          });
          this.addEventListener('dragstart', (event) => event.preventDefault());
          this.handle.addEventListener('keydown', (event) => this.onKey(event));

          this.set(this.value);
        }

        set(value) {
          this.value = Math.min(100, Math.max(0, value));
          this.style.setProperty('--ba-pos', this.value + '%');
          this.handle.setAttribute('aria-valuenow', String(Math.round(this.value)));
        }

        moveTo(clientX) {
          const rect = this.getBoundingClientRect();
          if (!rect.width) return;
          this.set(((clientX - this.grab - rect.left) / rect.width) * 100);
        }

        begin(event) {
          this.dragging = true;
          this.pending = null;
          this.classList.add('is-dragging');
          try {
            this.setPointerCapture(event.pointerId);
          } catch (error) {
            /* the pointer may already be gone */
          }

          // Grabbing the handle keeps the line where it is. Touching the picture sends the line to the finger or mouse.
          this.grab = 0;
          if (this.handle.contains(event.target)) {
            const rect = this.getBoundingClientRect();
            this.grab = event.clientX - (rect.left + (this.value / 100) * rect.width);
          }
          this.moveTo(event.clientX);
        }

        onDown(event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (this.pointerId !== null) return;
          this.pointerId = event.pointerId;

          // A finger that lands on the picture may be starting to scroll the page.
          // Wait to see which way it moves. Mouse, pen and the handle itself start straight away.
          if (event.pointerType === 'touch' && !this.handle.contains(event.target)) {
            this.pending = { x: event.clientX, y: event.clientY };
            return;
          }
          this.begin(event);
        }

        onMove(event) {
          if (event.pointerId !== this.pointerId) return;
          if (this.pending) {
            const dx = event.clientX - this.pending.x;
            const dy = event.clientY - this.pending.y;
            if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) this.begin(event);
            return;
          }
          if (this.dragging) this.moveTo(event.clientX);
        }

        onEnd(event) {
          if (event.pointerId !== this.pointerId) return;
          this.pointerId = null;
          this.pending = null;
          this.dragging = false;
          this.classList.remove('is-dragging');
          try {
            this.releasePointerCapture(event.pointerId);
          } catch (error) {
            /* already released */
          }
        }

        onKey(event) {
          const step = event.shiftKey ? 10 : 2;
          let next = null;
          switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
              next = this.value - step;
              break;
            case 'ArrowRight':
            case 'ArrowUp':
              next = this.value + step;
              break;
            case 'PageDown':
              next = this.value - 10;
              break;
            case 'PageUp':
              next = this.value + 10;
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = 100;
              break;
          }
          if (next === null) return;
          event.preventDefault();
          this.set(next);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('photo-reel')) {
    customElements.define(
      'photo-reel',
      class PhotoReel extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
          } else {
            this.setup();
          }
        }

        setup() {
          if (this.ready) return;
          this.track = this.querySelector('[data-track]');
          this.bar = this.querySelector('[data-bar]');
          this.thumb = this.querySelector('[data-thumb]');
          if (!this.track) return;
          this.ready = true;

          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();

          // Drag with the mouse. Touch screens already scroll by themselves.
          let startX = 0;
          let startLeft = 0;
          let down = false;
          let moved = false;
          this.track.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            down = true;
            moved = false;
            startX = e.clientX;
            startLeft = this.track.scrollLeft;
          });
          window.addEventListener('pointermove', (e) => {
            if (!down) return;
            const dx = e.clientX - startX;
            if (!moved && Math.abs(dx) > 4) {
              moved = true;
              this.track.classList.add('is-dragging');
            }
            if (moved) this.track.scrollLeft = startLeft - dx;
          });
          const stop = () => {
            if (!down) return;
            down = false;
            this.track.classList.remove('is-dragging');
          };
          window.addEventListener('pointerup', stop);
          window.addEventListener('pointercancel', stop);

          // Click on the bar to jump.
          if (this.bar) {
            this.bar.addEventListener('click', (e) => {
              const rect = this.bar.getBoundingClientRect();
              const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
              this.track.scrollTo({ left: ratio * (this.track.scrollWidth - this.track.clientWidth), behavior: 'smooth' });
            });
          }
        }

        update() {
          if (!this.track) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (this.bar) this.bar.hidden = max <= 2;
          if (!this.bar || !this.thumb || max <= 2) return;
          const share = Math.max(0.12, this.track.clientWidth / this.track.scrollWidth);
          this.thumb.style.width = share * 100 + '%';
          this.thumb.style.left = (this.track.scrollLeft / max) * (1 - share) * 100 + '%';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-list')) {
    customElements.define(
      'review-list',
      class ReviewList extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
          } else {
            this.setup();
          }
        }

        setup() {
          if (this.ready) return;
          this.list = this.querySelector('[data-list]');
          if (!this.list) return;
          this.ready = true;
          this.sortSelect = this.querySelector('[data-sort]');
          this.moreWrap = this.querySelector('[data-more-wrap]');
          this.moreButton = this.querySelector('[data-more]');
          this.step = parseInt(this.dataset.step, 10) || 6;
          this.visible = parseInt(this.dataset.initial, 10) || 6;

          if (this.sortSelect) this.sortSelect.addEventListener('change', () => this.sort(this.sortSelect.value));
          if (this.moreButton) {
            this.moreButton.addEventListener('click', () => {
              const before = this.visible;
              this.visible += this.step;
              this.render(before);
            });
          }
          this.render();
        }

        items() {
          return Array.from(this.list.querySelectorAll('.rl__item'));
        }

        sort(mode) {
          const num = (el, key) => parseInt(el.dataset[key], 10) || 0;
          const sorters = {
            featured: (a, b) => num(a, 'index') - num(b, 'index'),
            recent: (a, b) => num(b, 'date') - num(a, 'date') || num(a, 'index') - num(b, 'index'),
            highest: (a, b) => num(b, 'rating') - num(a, 'rating') || num(a, 'index') - num(b, 'index'),
            lowest: (a, b) => num(a, 'rating') - num(b, 'rating') || num(a, 'index') - num(b, 'index'),
          };
          this.items()
            .sort(sorters[mode] || sorters.featured)
            .forEach((el) => this.list.appendChild(el));
          this.render();
        }

        render(animateFrom) {
          const items = this.items();
          items.forEach((el, i) => {
            const show = i < this.visible;
            if (show && el.hidden && animateFrom !== undefined && i >= animateFrom) {
              el.classList.add('is-new');
              el.addEventListener('animationend', () => el.classList.remove('is-new'), { once: true });
            }
            el.hidden = !show;
          });
          if (this.moreWrap) this.moreWrap.hidden = this.visible >= items.length;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('video-testimonials')) return;

    var MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
    // A computer with a mouse. Phones and tablets do not match, so they keep playing on their own.
    var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

    function playMuted(video) {
      if (!video.paused) return;
      video.muted = true;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    class VideoTestimonials extends HTMLElement {
      connectedCallback() {
        // The element can be created before its contents are parsed, so wait for the page first.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      setup() {
        if (this._ready || !this.isConnected) return;
        this.track = this.querySelector('[data-vt-track]');
        if (!this.track) return;
        this._ready = true;

        this.items = Array.prototype.slice.call(this.track.querySelectorAll('.vt__item'));
        this.cards = this.items.map(function (li) { return li.querySelector('[data-vt-open]'); });
        this.stage = this.querySelector('.vt__stage');
        this.prevBtn = this.querySelector('[data-vt-prev]');
        this.nextBtn = this.querySelector('[data-vt-next]');
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
        this.rotate = this.dataset.rotate === 'true';
        this.hoverPlay = this.dataset.hoverPlay !== 'false';
        this.pointed = null;
        this.flags = { inView: false, hover: false, focus: false, modal: false, hidden: document.hidden };
        this.visible = new Set();
        this.timer = null;
        this.lock = 0;
        this.canScroll = false;
        this.index = 0;
        this.mutedPref = false;
        this.userPaused = false;

        // Click handlers go on the elements once. The observers and page listeners start again each time the element is added back.
        if (!this._wired) {
          this._wired = true;
          this.wireRow();
          this.wireModal();
        }
        this.startWatching();
        this.measure();
      }

      /* ---------- The row: rotation, arrows, which videos play ---------- */
      wireRow() {
        var self = this;
        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(-1); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(1); });

        this.track.addEventListener('click', function (e) {
          var card = e.target.closest('[data-vt-open]');
          if (card) self.open(self.cards.indexOf(card));
        });

        // A person who is looking at the row, or swiping it, should not have it move under them.
        this.stage.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') { self.flags.hover = true; self.sync(); }
        });
        this.stage.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse') { self.flags.hover = false; self.sync(); }
        });
        this.stage.addEventListener('focusin', function () { self.flags.focus = true; self.sync(); });
        this.stage.addEventListener('focusout', function () { self.flags.focus = false; self.sync(); });

        // On a computer a video plays while the mouse is on it (or it has keyboard focus) and pauses when the mouse leaves.
        this.cards.forEach(function (card) {
          card.addEventListener('pointerenter', function (e) {
            if (e.pointerType === 'mouse') self.point(card);
          });
          card.addEventListener('pointerleave', function (e) {
            if (e.pointerType === 'mouse') self.point(null, card);
          });
          card.addEventListener('focus', function () {
            var byKeyboard = false;
            try { byKeyboard = card.matches(':focus-visible'); } catch (err) { /* old browser: leave it paused */ }
            if (byKeyboard) self.point(card);
          });
          card.addEventListener('blur', function () { self.point(null, card); });
        });
        this.track.addEventListener('scroll', function () {
          if (performance.now() > self.lock) self.restart();
        }, { passive: true });

        // In the theme editor, selecting a video block brings it into view.
        this.addEventListener('shopify:block:select', function (e) {
          var li = e.target && e.target.closest ? e.target.closest('.vt__item') : null;
          if (!li || !self.canScroll) return;
          var pad = parseFloat(getComputedStyle(self.track).paddingLeft) || 0;
          var max = self.track.scrollWidth - self.track.clientWidth;
          self.lock = performance.now() + 900;
          self.track.scrollTo({ left: Math.min(Math.max(li.offsetLeft - pad, 0), max), behavior: 'smooth' });
          self.restart();
        });
      }

      startWatching() {
        var self = this;
        this.viewObserver = new IntersectionObserver(function (entries) {
          self.flags.inView = entries.some(function (e) { return e.isIntersecting; });
          self.sync();
        }, { threshold: 0.2 });
        this.viewObserver.observe(this);

        this.cardObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var card = e.target.querySelector('[data-vt-open]');
            if (e.isIntersecting) self.visible.add(card); else self.visible.delete(card);
          });
          self.syncPlayback();
        }, { root: this.track, threshold: 0.4 });
        this.items.forEach(function (li) { self.cardObserver.observe(li); });

        this.resizeObserver = new ResizeObserver(function () { self.measure(); });
        this.resizeObserver.observe(this.track);

        this.onVisibility = function () { self.flags.hidden = document.hidden; self.sync(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        this.onMotion = function () { self.sync(); };
        if (MOTION.addEventListener) MOTION.addEventListener('change', this.onMotion);

        this.onHoverChange = function () { self.syncPlayback(); };
        if (HOVER.addEventListener) HOVER.addEventListener('change', this.onHoverChange);

        // After "Add to cart" the cart drawer opens, so the pop-up gets out of its way.
        this.onCartAdded = function () { if (self.modal && self.modal.open) self.modal.close(); };
        document.addEventListener('cart:added', this.onCartAdded);
      }

      measure() {
        var t = this.track;
        this.canScroll = t.scrollWidth > t.clientWidth + 2;
        if (this.prevBtn) this.prevBtn.hidden = !this.canScroll;
        if (this.nextBtn) this.nextBtn.hidden = !this.canScroll;
        this.sync();
      }

      sync() {
        var f = this.flags;
        var run = this.rotate && this.canScroll && f.inView && !f.hover && !f.focus && !f.modal && !f.hidden && !MOTION.matches;
        if (run && !this.timer) {
          this.timer = setInterval(() => this.go(1, true), this.interval);
        } else if (!run && this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.syncPlayback();
      }

      restart() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = setInterval(() => this.go(1, true), this.interval);
      }

      // True on a computer with a mouse when "play on hover" is switched on in the section settings.
      hoverMode() {
        return this.hoverPlay && HOVER.matches;
      }

      // Remember which video the mouse (or keyboard focus) is on. Passing null only clears it if it is still that same video.
      point(card, from) {
        if (card) this.pointed = card;
        else if (this.pointed === from) this.pointed = null;
        this.syncPlayback();
      }

      // Only the videos that are on screen play, and only while nothing else is in the way.
      // With "play on hover" on a computer, only the video under the mouse plays and the rest stay paused.
      syncPlayback() {
        var f = this.flags;
        var onHover = this.hoverMode();
        var open = f.inView && !f.modal && !f.hidden;
        for (var i = 0; i < this.cards.length; i++) {
          var card = this.cards[i];
          var video = card.querySelector('video');
          if (!video) continue;
          var shown = this.visible.has(card);
          var want;
          if (onHover) {
            // Pointing at a video is the person's own choice, so it plays even with reduced motion switched on.
            want = open && shown && card === this.pointed;
            // Load the videos in view ahead of time so the one under the mouse starts at once. The cover image stays until it plays.
            if (shown && video.preload !== 'auto') video.preload = 'auto';
          } else {
            want = open && shown && !MOTION.matches;
          }
          if (want) playMuted(video);
          else if (!video.paused) video.pause();
        }
      }

      step() {
        var a = this.items[0];
        var b = this.items[1];
        return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
      }

      go(dir, auto) {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        if (max <= 2) return;
        var step = this.step() || 1;
        var pos = t.scrollLeft;
        var idx = Math.round(pos / step);
        var target;
        if (dir > 0) {
          target = pos >= max - 2 ? 0 : Math.min((idx + 1) * step, max);
        } else {
          target = pos <= 2 ? max : Math.max((idx - 1) * step, 0);
        }
        this.lock = performance.now() + 900;
        t.scrollTo({ left: target, behavior: MOTION.matches ? 'auto' : 'smooth' });
        if (!auto) this.restart();
      }

      /* ---------- The pop-up ---------- */
      wireModal() {
        var self = this;
        this.modal = this.querySelector('[data-vt-modal]');
        // Not called "slot": every HTML element already has a built-in text property with that name.
        this.panelSlot = this.querySelector('[data-vt-slot]');
        this.mVideo = this.querySelector('[data-vt-modal-video]');
        this.mHandle = this.querySelector('[data-vt-modal-handle]');
        this.mSound = this.querySelector('[data-vt-sound]');
        this.mBar = this.querySelector('[data-vt-bar]');
        this.mFill = this.querySelector('[data-vt-bar-fill]');
        this.peeks = Array.prototype.slice.call(this.querySelectorAll('[data-vt-peek-img]'));
        var video = this.mVideo;

        this.modal.addEventListener('close', function () { self.onClose(); });

        this.modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-vt-close]')) { self.modal.close(); return; }
          var nav = e.target.closest('[data-vt-nav]');
          if (nav) { self.show(self.index + parseInt(nav.getAttribute('data-vt-nav'), 10)); return; }
          if (e.target === self.modal || e.target.hasAttribute('data-vt-layout')) self.modal.close();
        });

        this.modal.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          // Leave the arrow keys alone while someone is choosing an option or an image.
          if (e.target.closest('.vt-modal__panel')) return;
          e.preventDefault();
          self.show(self.index + (e.key === 'ArrowRight' ? 1 : -1));
        });

        this.querySelector('[data-vt-toggle]').addEventListener('click', function () {
          if (video.paused) {
            self.userPaused = false;
            video.play().catch(function () {});
          } else {
            self.userPaused = true;
            video.pause();
          }
          self.modal.classList.toggle('is-paused', self.userPaused);
        });

        this.mSound.addEventListener('click', function () {
          video.muted = !video.muted;
          self.mutedPref = video.muted;
          self.updateSound();
        });

        video.addEventListener('timeupdate', function () {
          var d = video.duration;
          if (d && isFinite(d)) self.setProgress(video.currentTime / d);
        });

        this.mBar.addEventListener('pointerdown', function (e) {
          var rect = self.mBar.getBoundingClientRect();
          var d = video.duration;
          if (d && isFinite(d) && rect.width) {
            video.currentTime = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)) * d;
          }
        });
      }

      open(index) {
        if (index < 0 || !this.modal) return;
        this.opener = this.cards[index];
        this.flags.modal = true;
        this.sync();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.modal.classList.toggle('vt-modal--single', this.cards.length < 2);
        if (typeof this.modal.showModal === 'function') this.modal.showModal();
        else this.modal.setAttribute('open', '');
        this.show(index);
      }

      show(index) {
        var n = this.cards.length;
        this.index = ((index % n) + n) % n;
        var card = this.cards[this.index];
        var data = card.dataset;
        var video = this.mVideo;
        var self = this;

        this.userPaused = false;
        this.modal.classList.remove('is-paused');
        this.setProgress(0);

        video.pause();
        video.poster = data.poster || '';
        video.src = data.src;
        video.muted = this.mutedPref;
        this.updateSound();
        var attempt = video.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {
            // Some browsers refuse sound until the person taps again, so start muted instead.
            video.muted = true;
            self.mutedPref = true;
            self.updateSound();
            video.play().catch(function () {});
          });
        }

        this.mHandle.textContent = data.handle || '';
        this.modal.setAttribute('aria-label', data.handle ? 'Video from ' + data.handle : 'Video');

        var template = this.querySelector('template[data-vt-panel="' + data.id + '"]');
        this.panelSlot.textContent = '';
        if (template) {
          this.panelSlot.appendChild(template.content.cloneNode(true));
          this.modal.classList.remove('vt-modal--solo');
          var gallery = this.panelSlot.querySelector('[data-vt-gallery]');
          if (gallery) this.bindGallery(gallery);
          var body = this.panelSlot.querySelector('.vt-panel__body');
          if (body) body.scrollTop = 0;
        } else {
          this.modal.classList.add('vt-modal--solo');
        }

        this.setPeek(this.peeks[0], this.cards[(this.index - 1 + n) % n]);
        this.setPeek(this.peeks[1], this.cards[(this.index + 1) % n]);
      }

      setPeek(img, card) {
        if (!img) return;
        var poster = card && card.dataset.poster;
        if (poster) {
          img.src = poster;
          img.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      }

      setProgress(ratio) {
        this.mFill.style.transform = 'scaleX(' + Math.min(1, Math.max(0, ratio)) + ')';
      }

      updateSound() {
        var muted = this.mVideo.muted;
        this.mSound.setAttribute('data-muted', muted ? 'true' : 'false');
        this.mSound.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      }

      bindGallery(gallery) {
        var track = gallery.querySelector('.vt-gallery__track');
        var slides = Array.prototype.slice.call(track.children);
        var fill = gallery.querySelector('[data-vt-gallery-fill]');
        var prev = gallery.querySelector('[data-vt-gallery-prev]');
        var next = gallery.querySelector('[data-vt-gallery-next]');

        function update() {
          if (!fill) return;
          var w = track.clientWidth || 1;
          var i = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
          fill.style.width = ((i + 1) / slides.length) * 100 + '%';
        }
        update();
        track.addEventListener('scroll', update, { passive: true });
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });

        // The variant picker calls this to show the picture of the chosen option.
        gallery.showMedia = function (id) {
          for (var i = 0; i < slides.length; i++) {
            if (String(slides[i].getAttribute('data-media-id')) === String(id)) {
              track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
              return;
            }
          }
        };
      }

      onClose() {
        var video = this.mVideo;
        video.pause();
        video.removeAttribute('src');
        video.load();
        this.panelSlot.textContent = '';
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.flags.modal = false;
        if (!this._ready) return;

        // Show the last video that was watched, in case the person moved on with the arrows.
        var item = this.items[this.index];
        var t = this.track;
        if (item && this.canScroll) {
          var left = item.offsetLeft;
          if (left < t.scrollLeft || left + item.offsetWidth > t.scrollLeft + t.clientWidth + 1) {
            t.scrollTo({ left: left, behavior: 'auto' });
          }
        }

        var cartOpen = document.querySelector('cart-drawer.is-open, side-drawer.is-open');
        var back = this.cards[this.index] || this.opener;
        if (back && !cartOpen) back.focus({ preventScroll: true });
        this.sync();
      }

      teardown() {
        if (!this._ready) return;
        this._ready = false;
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.cardObserver) this.cardObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('cart:added', this.onCartAdded);
        if (MOTION.removeEventListener) MOTION.removeEventListener('change', this.onMotion);
        if (HOVER.removeEventListener) HOVER.removeEventListener('change', this.onHoverChange);
        this.pointed = null;
        if (this.modal && this.modal.open) {
          this.modal.close();
        }
      }
    }

    customElements.define('video-testimonials', VideoTestimonials);
  })();

  } catch(e) { console.error(e); }
})();
})();
